/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonIdAttachmentsAttachmentidStatus202,
  PutApiV1PersonIdAttachmentsAttachmentidStatus400,
  PutApiV1PersonIdAttachmentsAttachmentidStatus401,
  PutApiV1PersonIdAttachmentsAttachmentidStatus404,
  PutApiV1PersonIdAttachmentsAttachmentidStatus500,
  PutApiV1PersonIdAttachmentsAttachmentidStatusMutationRequest,
  PutApiV1PersonIdAttachmentsAttachmentidStatusMutationResponse,
  PutApiV1PersonIdAttachmentsAttachmentidStatusPathParams,
} from "../../types/personDocumentsController/PutApiV1PersonIdAttachmentsAttachmentidStatus.ts";
import { updatePersonAttachmentStatusViewModelSchema } from "../updatePersonAttachmentStatusViewModelSchema.ts";

export const putApiV1PersonIdAttachmentsAttachmentidStatusPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    attachmentId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1PersonIdAttachmentsAttachmentidStatusPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1PersonIdAttachmentsAttachmentidStatus202Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdAttachmentsAttachmentidStatus202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonIdAttachmentsAttachmentidStatus400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdAttachmentsAttachmentidStatus400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonIdAttachmentsAttachmentidStatus401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdAttachmentsAttachmentidStatus401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonIdAttachmentsAttachmentidStatus404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdAttachmentsAttachmentidStatus404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonIdAttachmentsAttachmentidStatus500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdAttachmentsAttachmentidStatus500>;

export const putApiV1PersonIdAttachmentsAttachmentidStatusMutationRequestSchema =
  z.lazy(
    () => updatePersonAttachmentStatusViewModelSchema,
  ) as unknown as ToZod<PutApiV1PersonIdAttachmentsAttachmentidStatusMutationRequest>;

export const putApiV1PersonIdAttachmentsAttachmentidStatusMutationResponseSchema =
  z.lazy(
    () => putApiV1PersonIdAttachmentsAttachmentidStatus202Schema,
  ) as unknown as ToZod<PutApiV1PersonIdAttachmentsAttachmentidStatusMutationResponse>;
